import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, palette, shape }: Theme) => ({
  radioGroup: {
    gap: 10,
    marginTop: 8,
  },
  verticalDirection: {
    flexDirection: 'row',
    gap: 0,
  },
  radio: {
    transition: 'all 200ms',
  },
  radioLabelRoot: {
    margin: 0,
    borderRadius: shape.borderRadius,
    color: custom.grey[2],
    marginRight: 0,
    '& > span:first-child': {
      width: 24,
      margin: 0,
      padding: 0,
      justifyContent: 'flex-start',
      marginRight: 8,
    },
    '&:hover': {
      '& $radio': {
        color: palette.primary.main,
      },
    },
  },
  radioLabelRootHorizontal: {
    marginRight: 20,
  },

  radioLabelRootActive: {
    borderColor: palette.primary.main,
  },
  radioLabelLabelActive: {
    color: palette.primary.main,
    '& $menuItemSubtitle': {
      color: palette.primary.main,
    },
    '& $icon': {
      color: palette.primary.main,
    },
  },
}));
